import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';
import { closeHeaderCatalog, showCatalogMenu, clearHeaderMenuDropdown, spriteIcon } from '../../tools/functions';

export const HeaderSecondMenu = {
    props: {
      fixed: String
    },
    
    data(){
      return {
        megamenuAutoScrollDelay: null,
        megamenuAnimationFrame: null,
        megamenuLastFrameTime: 0,
        megamenuActiveDirection: 1,
        megamenuActiveInner: null,
        megamenuActiveButton: null,
            megamenuResizeTimer: null
      };
    },
    computed: {
        ...mapState(vplSiteStore, ['menu', 'templateData'])
    },
    mounted(){
        window.addEventListener(
            'resize',
            this.scheduleMegamenuResizeRefresh
        );
    },
    beforeUnmount(){
        window.removeEventListener(
            'resize',
            this.scheduleMegamenuResizeRefresh
        );

        if (this.megamenuResizeTimer !== null) {
            window.clearTimeout(this.megamenuResizeTimer);
            this.megamenuResizeTimer = null;
        }

        this.stopMegamenuAutoScroll();
    },
    methods: {
        spriteIcon,
      megamenuIsAtBottom(inner){
        return inner.scrollTop + inner.clientHeight >= inner.scrollHeight - 4;
      },
      updateMegamenuScrollButton(inner){
        if (!inner) {
          return;
        }

        const dropdown = inner.closest('.header__bottom-nav-dropdown--big');
        const button = dropdown
          ? dropdown.querySelector('.tas-megamenu-scroll-button')
          : null;

        if (!dropdown || !button) {
          return;
        }

        const scrollable = inner.scrollHeight > inner.clientHeight + 4;
        dropdown.classList.toggle('tas-megamenu-scrollable', scrollable);

        if (!scrollable) {
          button.classList.remove('is-up');
          button.setAttribute('aria-label', 'Прокрутить меню вниз');
          button.setAttribute('title', 'Прокрутить меню вниз');
          return;
        }

        const showUp =
          this.megamenuIsAtBottom(inner)
          || (
            inner === this.megamenuActiveInner
            && this.megamenuActiveDirection < 0
          );

        button.classList.toggle('is-up', showUp);
        button.setAttribute(
          'aria-label',
          showUp ? 'Прокрутить меню вверх' : 'Прокрутить меню вниз'
        );
        button.setAttribute(
          'title',
          showUp ? 'Прокрутить меню вверх' : 'Прокрутить меню вниз'
        );
      },
        refreshAllMegamenuScroll(){
            document
                .querySelectorAll('.header__bottom-nav-dropdown--big')
                .forEach((dropdown) => {
                    this.refreshMegamenuScroll(dropdown);
                });
        },
        scheduleMegamenuResizeRefresh(){
            if (this.megamenuResizeTimer !== null) {
                window.clearTimeout(this.megamenuResizeTimer);
            }

            this.megamenuResizeTimer = window.setTimeout(() => {
                this.megamenuResizeTimer = null;
                this.stopMegamenuAutoScroll();
                this.refreshAllMegamenuScroll();
            }, 80);
        },
        refreshMegamenuScroll(dropdown){
        const element = dropdown && dropdown.nodeType
          ? dropdown
          : null;
        const inner = element
          ? element.querySelector('.header__bottom-nav-dropdown-inner')
          : null;

        if (!inner) {
          return;
        }

        window.requestAnimationFrame(() => {
          this.updateMegamenuScrollButton(inner);
        });
      },
      stopMegamenuAutoScroll(){
        if (this.megamenuAutoScrollDelay !== null) {
          window.clearTimeout(this.megamenuAutoScrollDelay);
          this.megamenuAutoScrollDelay = null;
        }

        if (this.megamenuAnimationFrame !== null) {
          window.cancelAnimationFrame(this.megamenuAnimationFrame);
          this.megamenuAnimationFrame = null;
        }

        if (this.megamenuActiveInner) {
          this.updateMegamenuScrollButton(this.megamenuActiveInner);
        }

        this.megamenuActiveInner = null;
        this.megamenuActiveButton = null;
        this.megamenuLastFrameTime = 0;
      },
      startMegamenuAutoScroll(button){
        this.stopMegamenuAutoScroll();

        const dropdown = button.closest('.header__bottom-nav-dropdown--big');
        const inner = dropdown
          ? dropdown.querySelector('.header__bottom-nav-dropdown-inner')
          : null;

        if (!inner || inner.scrollHeight <= inner.clientHeight + 4) {
          return;
        }

        this.megamenuActiveInner = inner;
        this.megamenuActiveButton = button;
        this.megamenuActiveDirection = this.megamenuIsAtBottom(inner) ? -1 : 1;
        this.updateMegamenuScrollButton(inner);

        this.megamenuAutoScrollDelay = window.setTimeout(() => {
          this.megamenuAutoScrollDelay = null;

          const autoScrollStep = (timestamp) => {
            if (!this.megamenuActiveInner) {
              return;
            }

            if (!this.megamenuLastFrameTime) {
              this.megamenuLastFrameTime = timestamp;
            }

            const elapsed = Math.min(timestamp - this.megamenuLastFrameTime, 40);
            this.megamenuLastFrameTime = timestamp;
            this.megamenuActiveInner.scrollTop += 
              elapsed * 0.28 * this.megamenuActiveDirection;
            this.updateMegamenuScrollButton(this.megamenuActiveInner);

            const reachedBoundary = this.megamenuActiveDirection > 0
              ? this.megamenuIsAtBottom(this.megamenuActiveInner)
              : this.megamenuActiveInner.scrollTop <= 0;

            if (reachedBoundary) {
              this.stopMegamenuAutoScroll();
              return;
            }

            this.megamenuAnimationFrame =
              window.requestAnimationFrame(autoScrollStep);
          };

          this.megamenuAnimationFrame =
            window.requestAnimationFrame(autoScrollStep);
        }, 220);
      },
      scrollMegamenu(event){
        const button = event.currentTarget;
        const dropdown = button.closest('.header__bottom-nav-dropdown--big');
        const inner = dropdown
          ? dropdown.querySelector('.header__bottom-nav-dropdown-inner')
          : null;

        if (!inner) {
          return;
        }

        this.stopMegamenuAutoScroll();
        const direction = this.megamenuIsAtBottom(inner) ? -1 : 1;
        inner.scrollBy({
          top: inner.clientHeight * 0.75 * direction,
          behavior: 'smooth'
        });

        window.setTimeout(() => {
          this.updateMegamenuScrollButton(inner);
        }, 380);
      },
      showCatalogMenu: showCatalogMenu,
      linkMouseEnter(link, menuItem){
        clearTimeout(this.menuOpenTimer);
        this.menuOpenTimer = setTimeout(() => {
          this.menuOpenTimer = null;
        if(menuItem.CHILDS && Object.keys(menuItem.CHILDS).length){
          if ($(window).width() > 991) {
            link = $(link);

            closeHeaderCatalog();
            $('.js-catalog').removeClass('is-active');
            $('.js-header').find('.js-catalog-dropdown').removeClass('is-open');

            if (!link.hasClass('is-open') && link.closest('.js-header-action-item').hasClass('has-child')) {
              link.addClass('is-open');
              link.closest('.js-header-action-item').find('.js-header-action-item-link-dropdown').addClass('is-show');

              if (!link.closest('.js-header-action-item').hasClass('js-bottom-menu')) {
                $('body').addClass('dropdown-open');
              } else {
                $('body').addClass('overlay-show');
              }
            }

          }
        }
        }, 500);
      },
      linkMouseLeave(){
        clearTimeout(this.menuOpenTimer);
        this.menuOpenTimer = null;
          if ($(window).width() > 991) {
              clearHeaderMenuDropdown();
          }
      },
      dropdownMouseEnter(dropdown){
          if ($(window).width() > 991) {
              $(dropdown).parent('.js-header-action-item').find('.js-header-action-item-link').addClass('is-open');
              this.refreshMegamenuScroll(dropdown);
              $(dropdown).addClass('is-show');

              if (!$(dropdown).parent('.js-header-action-item').hasClass('js-bottom-menu')) {
                $('body').addClass('dropdown-open');
              } else {
                $('body').addClass('overlay-show');
              }
          }
      },
      dropdownMouseLeave(){
        this.stopMegamenuAutoScroll();
          if ($(window).width() > 991) {
              clearHeaderMenuDropdown();
          }
      },
      closeMenu(){
        this.stopMegamenuAutoScroll();
        clearHeaderMenuDropdown();
      },
      clearPhone(phone){
        phone = phone.replace(/[^0-9+]/g,'');
        return 'tel:' + phone;
      }
    },
    template: `
        <a href="#" class="btn btn--green header__catalog js-catalog" @click.prevent="this.showCatalogMenu(false)">
            <div class="btn__icon">
                <svg class="ico ico-oborud" width="19" height="19" aria-hidden="true"><use xlink:href="#ico-oborud"></use></svg>
            </div>
            Каталог товаров
        </a>
        <nav v-if="this.menu.bottom" class="header__bottom-nav">
            <ul>
              <template v-for="menuItem in this.menu.bottom.ITEMS">
                <li v-if="this.fixed === undefined || this.fixed == 'Y' && menuItem.PARAMS.HIDE_IN_FIXED != 'Y' " class="js-header-action-item js-bottom-menu" :class="{'has-child': (menuItem.CHILDS && Object.keys(menuItem.CHILDS).length)}">
                  <a :href="menuItem.LINK" class="header__bottom-nav-link js-header-action-item-link"
                      @mouseenter="this.linkMouseEnter($event.target, menuItem)"
                      @mouseleave="this.linkMouseLeave()"
                      >

                    <div v-if="menuItem.PARAMS.ICON" class="header__bottom-nav-link-icon">
                      <svg v-if="spriteIcon(menuItem.PARAMS.ICON)" class="ico" :class="'ico-' + spriteIcon(menuItem.PARAMS.ICON)" width="20" height="20" aria-hidden="true"><use :xlink:href="'#ico-' + spriteIcon(menuItem.PARAMS.ICON)"></use></svg>
                      <img v-else :src="menuItem.PARAMS.ICON" :alt="menuItem.TEXT" :title="menuItem.TEXT">
                    </div>
                    {{ menuItem.TEXT }}
                    <svg class="icon icon-arrow-down"><use xlink:href="#icon-arrow-down"></use></svg>
                  </a>


                  <div v-if="menuItem.CHILDS && Object.keys(menuItem.CHILDS).length" class="header__bottom-nav-dropdown  js-header-action-item-link-dropdown"
                    @mouseenter="this.dropdownMouseEnter($event.target)"
                    @mouseleave="this.dropdownMouseLeave()"
                    :class="{'header__bottom-nav-dropdown--big': menuItem.PARAMS.BIG && menuItem.PARAMS.BIG == true}">

                    <template v-if="menuItem.PARAMS.BIG">
                      <div class="header__bottom-nav-dropdown-inner"
                        @scroll.passive="this.updateMegamenuScrollButton($event.currentTarget)">
                      <div class="container">
                        <a href="#" @click.prevent="this.closeMenu()" class="header__bottom-nav-dropdown-close js-header-dropdown-close">
                          <svg class="icon icon-close-lg"><use xlink:href="#icon-close-lg"></use></svg>
                        </a>
                        <div class="header__bottom-nav-dropdown-wp">

                          <template v-for="(childItem, iterationIndex) in menuItem.CHILDS">

                            <div class="header__bottom-nav-dropdown-block">
                              <a :href="childItem.LINK" class="header__bottom-nav-dropdown-block-title">
                                <div v-if="childItem.PARAMS.ICON" class="header__bottom-nav-dropdown-block-title-icon">
                                  <img class="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="childItem.PARAMS.ICON" :alt="childItem.TEXT" :title="childItem.TEXT">
                                  <img v-if="childItem.PARAMS.ICON_H" class="hover lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="childItem.PARAMS.ICON_H" :alt="childItem.TEXT" :title="childItem.TEXT">
                                  <img v-else class="hover lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="childItem.PARAMS.ICON" :alt="childItem.TEXT" :title="childItem.TEXT">
                                </div>
                                {{childItem.TEXT}}
                              </a>
                              <div v-if="childItem.PARAMS.DESCRIPTION" class="header__bottom-nav-dropdown-block-title-desc">
                                {{childItem.PARAMS.DESCRIPTION}}
                              </div>
                              <ul v-if="childItem.CHILDS && Object.keys(childItem.CHILDS).length" class="header__bottom-nav-dropdown-block-list">
                                <template v-for="(subItem, iterationSubIndex) in childItem.CHILDS">
                                  <li>
                                    <a :href="subItem.LINK">{{subItem.TEXT}}</a>
                                  </li>
                                </template>
                              </ul>
                            </div>

                            <div v-if="childItem.PARAMS.SECTION_COUNTER === 1" class="header__bottom-nav-dropdown-block header__bottom-nav-dropdown-block--informer lazy-bg">
                              <div class="header__bottom-nav-dropdown-block-name" v-if="Object.keys(menuItem.PARAMS.TITLE).length">
                                {{menuItem.PARAMS.TITLE}}
                              </div>
                              <div class="header__bottom-nav-dropdown-block-text" v-if="Object.keys(menuItem.PARAMS.DESC).length">
                                {{menuItem.PARAMS.DESC}}
                              </div>
                              <div class="contacts-socials">
                                <a v-if="templateData && templateData.phone && templateData.phone.CONTENT" :href="clearPhone(templateData.phone.CONTENT)" class="contacts-socials__tel">{{ templateData.phone.CONTENT }}</a>

                                <div v-if="templateData && templateData.menuMessengers" class="contacts-socials__links">
                                  <a v-for="mess in templateData.menuMessengers" :href="mess.LINK" target="_blank" rel="nofollow"
                                     :data-messenger-channel="mess.ICON" data-messenger-placement="header">
                                    <svg :class="'icon ' + mess.ICON"><use :xlink:href="'#' + mess.ICON"></use></svg>
                                  </a>
                                </div>
                              </div>
                              <a href="#" data-toggle="modal" data-target="#contactUs" class="btn btn--green dropdown-btn">Связаться с нами</a>
                            </div>
                          </template>


                        </div>
                      </div>
                      </div>
                      <div class="tas-megamenu-scroll-control" aria-hidden="true">
                        <button type="button"
                          class="tas-megamenu-scroll-button"
                          aria-label="Прокрутить меню вниз"
                          title="Прокрутить меню вниз"
                          @mouseenter="this.startMegamenuAutoScroll($event.currentTarget)"
                          @mouseleave="this.stopMegamenuAutoScroll()"
                          @blur="this.stopMegamenuAutoScroll()"
                          @click.prevent="this.scrollMegamenu($event)">
                          <span class="tas-megamenu-scroll-button-arrow"></span>
                        </button>
                      </div>
                    </template>
                    <template v-else>

                      <a v-for="childItem in menuItem.CHILDS" :href="childItem.LINK" class="header__bottom-nav-dropdown-link">
                        <div v-if="childItem.PARAMS.ICON !== false" class="header__bottom-nav-dropdown-link-icon">
                          <img class="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="childItem.PARAMS.ICON" :alt="childItem.TEXT" :title="childItem.TEXT">
                          <img v-if="childItem.PARAMS.ICON_H !== false" class="hover lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="childItem.PARAMS.ICON_H" :alt="childItem.TEXT" :title="childItem.TEXT">
                          <img v-else class="hover lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="childItem.PARAMS.ICON" :alt="childItem.TEXT" :title="childItem.TEXT">
                        </div>
                        {{childItem.TEXT}}
                      </a>
                    </template>
                  </div>
                </li>
              </template>
            </ul>
            <button v-if="this.menu.bottom.EDIT_BUTTON" :onclick="this.menu.bottom.EDIT_BUTTON">Редактировать пункты меню</button>
        </nav>
    `
}